// Loads Paddle.js v2 once and initializes it with the client-side token.
let _initialized = false;

export function loadPaddle(token, environment = "production", eventCallback) {
  return new Promise((resolve, reject) => {
    const finishInit = () => {
      try {
        if (!_initialized) {
          if (environment === "sandbox" && window.Paddle?.Environment?.set) {
            window.Paddle.Environment.set("sandbox");
          }
          window.Paddle.Initialize({ token, eventCallback });
          _initialized = true;
        }
        resolve(true);
      } catch (e) {
        reject(e);
      }
    };
    if (window.Paddle) return finishInit();
    const existing = document.getElementById("paddle-js");
    if (existing) {
      existing.addEventListener("load", finishInit);
      existing.addEventListener("error", () => reject(new Error("Paddle.js failed to load")));
      return;
    }
    const s = document.createElement("script");
    s.id = "paddle-js";
    s.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
    s.async = true;
    s.onload = finishInit;
    s.onerror = () => reject(new Error("Paddle.js failed to load"));
    document.body.appendChild(s);
  });
}

export const money = (amount, currency = "usd") => {
  const c = (currency || "usd").toLowerCase();
  if (c === "inr") return `₹${Number(amount).toLocaleString("en-IN")}`;
  return `$${Number(amount).toLocaleString("en-US")}`;
};
